import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'underscore';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { Observable } from 'rxjs';
@Component({
    selector: 'app-email-campaign-filter',
    templateUrl: './email-campaign-filter.component.html',
    styleUrls: ['./email-campaign-filter.component.scss'],
    standalone: false
})
export class EmailCampaignFilterComponent implements OnInit {


    @Input() numberOfStages;
    @Output() filterChange: EventEmitter<{ emailFilter?: string, statusFilter?: string }> = new EventEmitter();
    @Input() events: Observable<void>;

    emailFilter: any ='All';
    @Input() statusFilter: any;
    stepsFilter: any = [];
    selectedSteps: any = [];
    /**List of present Steps */
    stepsList: any = [];

    filterObject:any ={}
    stepSelection = null;
  constructor(private _localstorageservice: LocalStorageService) { }

  ngOnInit() {
    const filterObj = this._localstorageservice.getItem('email-campaign-filters');
    this.emailFilter = filterObj?.emailFilter;
    if( (filterObj?.statusFilter === 'unsubscribed') || (filterObj?.statusFilter === 'true') || (filterObj?.statusFilter === 'false')){
      this.statusFilter = filterObj?.statusFilter;
    }
    // this.statusFilter = filterObj?.statusFilter;
    this.stepsFilter = filterObj?.stepsFilter;
    this.selectedSteps = (this.stepsFilter && this.stepsFilter.length) ? this.stepsFilter.map(res=>('Step ' + res)) : []
    this.events.subscribe((res:any)=>{
      this.numberOfStages = res;
      this.stepsList = [];
      for(let i=0; i<this.numberOfStages; i++){
        this.stepsList.push('Step ' + (i+1));
      }
    });

  }

  filterSlider_close() {
    const sidebar = document.getElementById("mySidebar_email_filter");
    const overlay = document.getElementById("myOverlay_email_filter");

    if (sidebar) {
      sidebar.style.display = "none";
    }

    if (overlay) {
      overlay.style.display = "none";
    }
  }

  resetFilter() {
    this.emailFilter = 'All';
    this.stepSelection = null;
    this.statusFilter = 'All';
    this.filterObject = {};
    this.selectedSteps = [];
    this.stepsFilter = [];

    this.updateFilter();

    document.getElementById("mySidebar_email_filter")?.style.setProperty('display', 'none');
    document.getElementById("myOverlay_email_filter")?.style.setProperty('display', 'none');
  }

  updateFilter(){
    this._localstorageservice.setItem('email-campaign-filters',{emailFilter:this.emailFilter,statusFilter:this.statusFilter,stepsFilter:this.stepsFilter});
      this.filterObject['emailFound'] = this.emailFilter;

      if(this.statusFilter === 'unsubscribed'){
        if (this.filterObject['replied']) delete this.filterObject['replied'];
        if(this.filterObject['opened']) delete this.filterObject['opened'];
        if (Array.isArray(this.filterObject['status[]'])) {
          this.filterObject['status[]'] = [];
        }
        this.filterObject['status[]'] = (Array.isArray(this.filterObject['status[]'])) ? [...this.filterObject['status[]'],9] : [9];
      } else if (this.statusFilter === 'completed') {
        if (this.filterObject['replied']) delete this.filterObject['replied'];
        if(this.filterObject['opened']) delete this.filterObject['opened'];
        if (Array.isArray(this.filterObject['status[]'])) {
          this.filterObject['status[]'] = [];
        }
        this.filterObject['status[]'] = (Array.isArray(this.filterObject['status[]'])) ? [...this.filterObject['status[]'],3] : [3];
      } else if (this.statusFilter === 'replied') {
        if(this.filterObject['opened']) delete this.filterObject['opened'];
        if (Array.isArray(this.filterObject['status[]'])){
          this.filterObject['status[]'] = this.filterObject['status[]'].filter(x=>(x !=9 && x !=3));
        }
        this.filterObject['replied'] = 'true';
      } else {
        if (this.filterObject['replied']) delete this.filterObject['replied'];
        if(Array.isArray(this.filterObject['status[]'])){
          this.filterObject['status[]'] = this.filterObject['status[]'].filter(x=>(x != 9 && x !=3));
        }
        this.filterObject['opened'] = this.statusFilter
      };
      this.filterObject['stage[]'] = this.stepsFilter;
      this.filterChange.emit(this.filterObject);
  }

  selectedItem(event) {
    if (event && event?.value) {
      this.selectedSteps.push(event?.value);
      this.stepsFilter = (this.selectedSteps?.length) ? this.selectedSteps.map(element => {
        return Number(element.split(' ')[1]);
      }) : [];
      this.stepsList = this.stepsList.filter((x)=> x!=event?.value);
      this.updateFilter();
    }
  }

  removeChip(value, type) {
    this.stepSelection = null;
    this.stepsList.push(value);
    this.stepsList.sort();
    this.selectedSteps = this.selectedSteps.filter(item => item !== value);
    this.stepsFilter =(this.selectedSteps.length) ? this.selectedSteps.map(element => {
      return Number(element?.split(' ')[1]);
    }) : [];
    this.updateFilter();
  }
}
